import { SignUpUserRequestDto, SignUpUserResponseDto } from 'types/types';
import { request as __request } from '../request/request';
import { OpenAPI } from '../request/open-api';

export function createAdmin(userData: SignUpUserRequestDto) {
  return __request<SignUpUserResponseDto>(OpenAPI, {
    method: 'POST',
    url: '/admin/create-user',
    body: userData,
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
}
